import {tr} from '../i18n/idioma';
import {numero} from './formato';

// Tenor promedio ponderado de lo filtrado para la linea de totales (Daniel,
// 26/10/2026): gramos / toneladas secas, nunca el promedio simple de los tenores.
export const chipsDeTenor = (t: {tonSecas: number; auG: number; agG: number}): Array<[string, string]> => {
  const tenor = (gramos: number) => (t.tonSecas > 0 ? numero(gramos / t.tonSecas, 1) : '—');
  return [
    [tr('Tenor Au (g/t)', 'Au grade (g/t)'), tenor(t.auG)],
    [tr('Tenor Ag (g/t)', 'Ag grade (g/t)'), tenor(t.agG)],
  ];
};
